import { BroadcastReplyType } from 'types'
import axios from 'api/axios'

export interface GetBroadcastRepliesParams {
	page: number
	size: number
	broadcastId: string
}

export interface GetBroadcastRepliesResponse {
	filter: {
		broadcast: string
	}
	response: {
		currentPage: number
		records: Array<BroadcastReplyType>
		totalCount: number
		totalPages: number
	}
}

const getBroadcastReplies = async (
	params: GetBroadcastRepliesParams
): Promise<GetBroadcastRepliesResponse> => {
	const { broadcastId } = params

	if (!broadcastId) {
		throw new Error('BroadcastId is required')
	}

	const response = await axios.get(
		`v1/broadcast/management/broadcast-reply/${broadcastId}`,
		{
			params: {
				...params,
				broadcastId: undefined,
			},
		}
	)

	if (!response) {
		throw new Error('No response')
	}

	return response.data
}

export default getBroadcastReplies
